import { Button, Modal, Spin } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import PopUp from '../pages/pharmacists/ViewProfile/PopUp/PopUp'
import { LoadingOutlined } from '@ant-design/icons';
import ImageWithSkeleton from './ImageWithSkeleton';

function CardPastPrescription({ data, ConditionName, userId, setFlagFetch }) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [pastValue, setPastValue] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const handleCloseModal = () => {
        setIsModalVisible(false);
    };
    const handleTabChange = (key) => {
        setIsModalVisible(true);
        setPastValue("past");
    };
    const handleTabRepeat = (key) => {
        setIsModalVisible(true);
        setPastValue("");

    };
    const handleImageLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        if (data.prescriptionImage) {
            setLoading(false);

        }
    }, [isModalOpen]);
    return (
        <>
            <PopUp visible={isModalVisible} onClose={handleCloseModal} data={data} past={pastValue} ConditionName={ConditionName} userIdPast={userId} setFlagFetch={setFlagFetch} />
            <div className='my-10 space-y-5 border p-5 border-[#E0EAFC] ml-14  TimeLine relative '>
                <div className='absolute t-[0] left-[-55px]'>
                    <p className='text-sm font-medium text-[#000000]'>
                        {data.createdAt
                            ? <>
                                {moment(data.createdAt).format("DD")}
                                <br />
                                {moment(data.createdAt).format("MMM")}
                            </>
                            : "No Date"}
                    </p>
                </div>
                <div className='flex space-x-5 w-full'>
                    <div className='w-[70px] h-[70px] '>
                        <ImageWithSkeleton 
                            noRounded={true}
                            src={data.medicineDetails?.image || 'https://s3.us-east-2.amazonaws.com/followvita.com/src/47dd4265-9e57-479a-adc7-b8acab1489c6_Rectangle%202757.png'} 
                            alt="Medicine" 
                            className="w-full h-full"
                            classNameInIMage="w-full h-full"
                        />
                    </div>

                    <div className='flex flex-col w-[90%] '>
                        <div className='flex justify-between mt-2'>
                            <h2>Condition: {ConditionName} </h2>
                            <p style={{ fontSize: "16px", fontWeight: "600", }}>{data.name}</p>
                            {/* <img src="../../public/edit-2.svg" alt="icon" className=""/> */}
                        </div>
                        {/* <div className='flex flex-row justify-between'>
                            <p style={{ fontSize: "14px", fontWeight: "400", }}>Pharmacy: {data.Pharmacy}</p>
                            <p style={{ fontSize: "14px", fontWeight: "400", }}>Given by: {data.Given_by}</p>
                        </div> */}
                    </div>
                </div>
                <div className='flex justify-between'>
                    {data.prescriptionImage ?
                        <Button
                            style={{ padding: "20px", color: "#A9A9A9" }}
                            onClick={() => setIsModalOpen(true)}
                        >
                            View Attachments
                        </Button>
                        : null}
                    <Button onClick={handleTabChange} style={{ color: "#3371EB", borderColor: "#3371EB", padding: "20px", fontSize: "14px", fontWeight: "400" }}>
                        View Prescription
                    </Button>
                    <Button onClick={handleTabRepeat} style={{ color: "white", backgroundColor: "#3371EB", borderColor: "#3371EB", padding: "20px", fontSize: "14px", fontWeight: "400" }}>
                        Repeat Presc
                    </Button>
                </div>
            </div>

            <Modal
                title="Prescription Attachment"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={600}
            >
                {loading ? (
                    <Spin indicator={<LoadingOutlined spin />} />
                ) : data.prescriptionImage ? (
                    <img
                        src={data.prescriptionImage}
                        alt="Prescription"
                        style={{ width: "100%", borderRadius: "8px" }}
                        onLoad={handleImageLoad} // Trigger loading state to false after the image is loaded
                    />
                ) : (
                    <p>No attachment available</p>
                )}
            </Modal>
        </>
    )
}

export default CardPastPrescription
